<template>
  <!-- PC表示 -->
  <div
    class="sidebar d-none d-lg-flex">
    <nav
      class="side-nav p-3 pt-6">
      <ul
        class="side-nav__list list-unstyled"
        style="position: fixed;">
        <li class="side-nav__item mb-4">
          <div
            class="side-nav__item">
            <img
              src="@/assets/images/logo@2x.png"
              class="side-nav__logo">
          </div>
        </li>
        <li
          v-if="!isParentMember"
          class="side-nav__item">
          <router-link
            :to="homeRoute"
            class="pt-3 pb-3 side-nav__link"
            :class="{'side-nav__link--current': currentPageIs(homeRoute)}">
            <span class="side-nav__icon material-icons">
              home
            </span><span class="side-nav__text">ホーム</span>
          </router-link>
        </li>
        <li
          v-if="!isParentMember"
          class="side-nav__item">
          <router-link
            to="/search"
            class="pt-3 pb-3 side-nav__link"
            :class="{'side-nav__link--current': currentPageIs('/search')}">
            <span class="side-nav__icon material-icons">
              search
            </span><span class="side-nav__text">検索</span>
          </router-link>
        </li>
        <li
          v-if="!isParentMember"
          class="side-nav__item">
          <router-link
            to="/notifications"
            class="side-nav__link pt-3 pb-3"
            style="position: relative;"
            :class="{'side-nav__link--current': currentPageIs('/notifications')}">
            <img
              v-if="hasNotifications"
              src="@/assets/images/notification-badge.svg"
              class="notification-badge--pc">
            <span class="side-nav__icon material-icons">
              notifications
            </span><span class="side-nav__text">通知</span>
          </router-link>
        </li>
        <li
          v-if="isParentMember"
          class="side-nav__item">
          <router-link
            to="/members"
            class="pt-3 pb-3 side-nav__link"
            :class="{'side-nav__link--current': currentPageIs('/members')}">
            <span class="side-nav__icon material-icons">
              people
            </span><span class="side-nav__text">メンバー</span>
          </router-link>
        </li>
        <li
          v-if="isManager"
          class="side-nav__item">
          <router-link
            to="/admin/records"
            class="pt-3 pb-3 side-nav__link"
            :class="{'side-nav__link--current': isRecordListPage}">
            <span class="side-nav__icon material-icons">
              group
            </span><span class="side-nav__text">記録一覧</span>
          </router-link>
        </li>
        <template v-if="canAccessEvents">
          <li
            v-if="isParentMember"
            class="side-nav__item">
            <div
              v-if="currentPageIs('/events')"
              class="side-nav__link pt-3 pb-3 side-nav__link--current"
              @click="refreshPage">
              <span class="side-nav__icon material-icons">
                refresh
              </span><span class="side-nav__text">更新</span>
            </div>
            <router-link
              v-else
              to="/events"
              class="pt-3 pb-3 side-nav__link">
              <span class="side-nav__icon material-icons">
                refresh
              </span><span class="side-nav__text">更新</span>
            </router-link>
          </li>
          <li
            v-else
            class="side-nav__item">
            <router-link
              to="/events"
              class="pt-3 pb-3 side-nav__link"
              :class="{'side-nav__link--current': currentPageIs('/events')}">
              <span class="side-nav__icon material-icons">
                event
              </span><span class="side-nav__text">予定表</span>
            </router-link>
          </li>
        </template>
        <li class="side-nav__item">
          <router-link
            to="/settings"
            class="pt-3 pb-3 side-nav__link"
            :class="{'side-nav__link--current': currentPageIs('/settings')}">
            <span class="side-nav__icon material-icons">
              settings
            </span><span class="side-nav__text">設定</span>
          </router-link>
        </li>
      </ul>
    </nav>
    <!-- PC表示 end -->
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
export default {
  computed: {
    ...mapState('auth', ['user']),
    ...mapState(['hasNotifications']),
    ...mapGetters('auth', ['canAccessEvents', 'isParentMember', 'isManager']),
    homeRoute() {
      if (!this.user){
        return '/'
      }
      return `/members/${this.user.id}`
    },
    isRecordListPage() {
      return this.$route.path.startsWith('/admin/records')
    },
  },
  methods: { 
    currentPageIs(path) {
      return this.$route.path === path
    },
    refreshPage() {
      window.location.reload()
    }
  }
}
</script>

<style lang="scss" scoped>
.notification-badge--pc {
  position: absolute;
  top: 15%;
  left: 67%;
}
</style>